/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import FoodItem from "../item/Item";
import { putItemList } from "../item/item-list/putItemListSlice";

const itemMargin = {
  m: 1,
};

function ItemList() {
  const dispatch = useDispatch();
  const location = useLocation();
  let itemList;
  try {
    itemList = JSON.parse(localStorage.getItem(location.pathname));
  } catch (error) {
    console.error("Failed to parse itemList", error);
  }
  console.log("ItemList", itemList);
  useEffect(() => {
    console.log("Recommended item list", itemList);
    const putPayload = {
      items: itemList.displayed_items,
      view: "RECOMMENDED_VIEW",
    };
    dispatch(putItemList(putPayload));
  }, [itemList]);

  return (
    <>
      {itemList.displayed_items.map((item) => (
        <Grid item xs={6} sm={4} md={3} lg={2} key={item.item_id}>
          <Box sx={itemMargin}>
            <FoodItem item={item} />
          </Box>
        </Grid>
      ))}
    </>
  );
}

export default ItemList;
